module.exports = __webpack_public_path__ + "img/banner3.437ba0cc.png";